import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from './../../../environments/environment';

@Injectable()
export class VariablePayService {

  headers;

  constructor(private http: HttpClient) { }

  /* Getting Headers */
  getHeaders() {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'access-token': localStorage.getItem('access-token'),
      'client': localStorage.getItem('client'),
      'expiry': localStorage.getItem('expiry'),
      'uid': localStorage.getItem('uid')
    });
  }

  getFileHeaders() {
    this.headers = new HttpHeaders({
      'access-token': localStorage.getItem('access-token'),
      'client': localStorage.getItem('client'),
      'expiry': localStorage.getItem('expiry'),
      'uid': localStorage.getItem('uid')
    });
  }

  /* Setting Headers */
  setHeaders(data) {
    if (data.headers.get('access-token') != null) {
      localStorage.setItem('access-token', data.headers.get('access-token'));
      localStorage.setItem('client', data.headers.get('client'));
      localStorage.setItem('expiry', data.headers.get('expiry'));
      localStorage.setItem('uid', data.headers.get('uid'));
    }
  }

  /* Employees List API */
  getEmployeesList(params): Observable<any> {
    this.getHeaders();
    return this.http.get(environment.api_url + '/variable_pays', { headers: this.headers, params: params, observe: 'response' });
  }

  getAccountsList() {
    this.getHeaders();
    return this.http.get(environment.api_url + '/accounts', { headers: this.headers, observe: 'response' });
  }

  getAssessmentYearsList() {
    this.getHeaders();
    return this.http.get(environment.api_url + '/assessment_years', { headers: this.headers, observe: 'response' });
  }

  createVariablePay(variable_pay) {
    this.getHeaders();
    const data = { variable_pay };
    return this.http.post(environment.api_url + '/variable_pays', data, { headers: this.headers, observe: 'response' });
  }

  bulkUploadVariablePay(file) {
    this.getFileHeaders();
    let formData = new FormData();
    formData.append('variable_pay_file', file);
    return this.http.post(environment.api_url + '/variable_pays/bulk_upload', formData, { headers: this.headers, observe: 'response' });
  }

  getpostPayList(variable_pay, id) {
    this.getHeaders();
    const data = { variable_pay };
    return this.http.put(environment.api_url + '/variable_pays/' + id, data, { headers: this.headers, observe: 'response' });
  }

  deletePayList(id) {
    this.getHeaders();
    return this.http.delete(environment.api_url + '/variable_pays/' + id, { headers: this.headers, observe: 'response' });
  }


}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/services/variable-pay/variable-pay.service.ts